import React, { useEffect, useState } from 'react'
import DevicesGridInfoTable from './DevicesGridInfoTable'
import DevicesInfo from './DevicesInfo'
import PeripheralsTab from './PeripheralsTab'
import CustomSpinner from '../../../components/CustomSpinner'
import { getListGroup } from '../../../axios/Group/GroupUrlApi'
import { getUserList } from '../../../axios/User/UserApi'
import { LoadingProvider } from '../../../context/LoadingContext'
import { useRefresh } from '../../../context/RefreshContext'

const Devices = () => {
    const [GroupData, setGroupData] = useState([])
    const [selectedRow, setSelectedRow] = useState({});
    const [selectedRows, setSelectedRows] = useState({});
    const [selectedRows1, setSelectedRows1] = useState({
        deviceCode: "",
        description: "",
        application: "",
        isBlock: null,
        operatingSystem: "",
        osVersion: "",
        deviceConfiguration: "",
        kioskMode: null,
        userName: "",
        password: "",
        lastAccess: "",
        lastUpdated: "",
        assignedTo: "",
        licensed: null,
        createdTime: "",
        peripheral: [],
        groupCode: [],
        status: null,
        deviceId: ""
    });

    const handleRowSelection = (newSelection) => {
        setSelectedRows(newSelection);
    }

    const handleRowDoubleClick = (employee) => {
        setSelectedRow(employee);
    };

    const fetchListGroup = async () => {
        const payload = {
            pageNo: 1,
            recordPerPage: 50000,
            langId: localStorage.getItem("i18nextLngId")
        }
        try {
            setLoading(true);
            const response = await getListGroup(payload);
            setGroupData(response.data.data)
        } catch (error) {
            console.log(error)
        }
    };
    useEffect(() => {
        fetchListGroup()
    }, []);
    
    const {refreshData, handleRefreshData} = useRefresh();
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [loading, setLoading] = useState(false);

    const [allUser, setAllUser] = useState([]);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const payload = {
                    statusId: 1,
                    page: 1,
                    pageSize: 500,
                    status: null,
                    langId: localStorage.getItem("i18nextLngId")
                }
                const response = await getUserList(payload);
                const usersList = response.data.data;
                setAllUser(usersList);
            } catch (error) {
                console.log(error)
            }
        };
        fetchUser();

    }, []);

    return (
        <div className='devices'>
            <div className='grid grid-cols-12 gap-x-5 gap-y-5 items-stretch'>
                <div className='col-span-12 2xl:col-span-6 flex min-h-[83vh]'>
                    <div className='card px-3 py-2 w-full flex-1 flex flex-col min-h-0'>
                        <div className='flex-1 min-h-0 [&>div]:h-full [&>div>div]:h-full'>
                            <LoadingProvider>
                                <DevicesGridInfoTable
                                    onRowSelection={handleRowSelection}
                                    page={page}
                                    pageSize={pageSize}
                                    refreshData={refreshData}
                                    setPage={setPage}
                                    setPageSize={setPageSize}
                                    setLoading={setLoading}
                                    onRefresh={handleRefreshData}
                                    GroupData={GroupData}
                                    usersData={allUser}
                                    onRowClick={setSelectedRow} onRowDoubleClick={handleRowDoubleClick}
                                />
                            </LoadingProvider>
                        </div>
                    </div>
                </div>
                <div className='col-span-12 2xl:col-span-6 flex min-h-[83vh]'>
                    <div className='w-full flex-1 min-h-0 [&>div]:h-full [&>div>div]:h-full'>
                        <LoadingProvider>
                            <DevicesInfo
                                info={selectedRow}
                                usersData={allUser}
                                GroupData={GroupData}
                                refreshData={refreshData}
                                onRefresh={handleRefreshData}
                            />
                        </LoadingProvider>
                    </div>
                    {/* <div className='mt-5 relative opacity-[0.5] pointer-events-none'>
                        <LoadingProvider>
                            <PeripheralsTab
                                info={selectedRows1}
                            // onRowSelection={handleRowSelection}
                            />
                        </LoadingProvider>
                    </div> */}
                </div>
            </div>
            {/* {
                loading && <CustomSpinner loading={loading} />
            } */}
        </div>
    )
}

export default Devices